<glxy-page [isLoading]="isLoading() || !connectionStatesBySourceId()">
  <glxy-page-toolbar>
    <glxy-page-title>{{ 'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.TITLE' | translate }}</glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [useHistory]="true"
        [useRelativePath]="true"
        [previousPageUrl]="previousPageUrl"
      ></glxy-page-nav-button>
    </glxy-page-nav>
  </glxy-page-toolbar>
  <glxy-page-wrapper widthPreset="narrow">
    <form [formGroup]="settingsForm">
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{
            'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.CARD_TITLE' | translate
          }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <glxy-form-field size="medium">
            <mat-select placeholder="--" formControlName="rating">
              @for (option of starOptions; track option) {
                <mat-option [value]="option.value">
                  {{ option.label | translate }}
                </mat-option>
              }
            </mat-select>
            <glxy-hint>
              {{ 'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.RATING_HINT' | translate }}
            </glxy-hint>
          </glxy-form-field>

          <glxy-form-field>
            <glxy-label class="platforms-label">{{
              'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.PLATFORMS_LABEL' | translate
            }}</glxy-label>
            <glxy-list-container class="list-group">
              @for (source of availableSources; track source.key) {
                <glxy-list-item class="sources-list">
                  <mat-checkbox [checked]="isSourceSelected(source.key)" (change)="toggleSource(source.key)">
                    <span>{{ source.label | translate }}</span>
                    @if (source.key === ReviewSourceConnectionConfig['facebook'].sourceId) {
                      <mat-icon
                        class="info-icon"
                        [tooltipTitle]="
                          'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.FACEBOOK_RATING_INFO.TITLE'
                        "
                        [glxyTooltip]="
                          'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.FACEBOOK_RATING_INFO.CONTENT'
                        "
                        [highContrast]="false"
                        (click)="$event.preventDefault(); $event.stopPropagation()"
                        (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                      >
                        info_outline
                      </mat-icon>
                    }
                  </mat-checkbox>
                  <span glxyListItemAccessory>
                    @if (connectionStatesBySourceId()) {
                      @switch (connectionStatesBySourceId()![source.key]) {
                        @case (ReviewSourceConnectionState.Connected) {
                          <glxy-label class="connected-state">
                            {{
                              'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.CONNECTION_STATE.CONNECTED'
                                | translate
                            }}
                          </glxy-label>
                        }
                        @case (ReviewSourceConnectionState.Disconnected) {
                          <a
                            (click)="
                              navigateToIntegrations(source.key); $event.preventDefault(); $event.stopPropagation()
                            "
                          >
                            {{
                              'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.CONNECTION_STATE.RECONNECT'
                                | translate
                            }}
                          </a>
                        }
                        @default {
                          <a
                            (click)="
                              navigateToIntegrations(source.key); $event.preventDefault(); $event.stopPropagation()
                            "
                          >
                            {{ 'COMMON.CONNECT' | translate }}
                          </a>
                        }
                      }
                    }
                  </span>
                </glxy-list-item>
              }
            </glxy-list-container>
          </glxy-form-field>

          <div class="delay-selector">
            <glxy-form-field style="width: 100px">
              <input
                type="number"
                placeholder="--"
                [min]="minLimit"
                [max]="maxLimit"
                matInput
                formControlName="delayValue"
              />
            </glxy-form-field>
            <glxy-form-field size="medium" style="width: 100px">
              <mat-select placeholder="--" formControlName="delayUnit">
                @for (option of delayOptionsInPeriod; track option) {
                  <mat-option [value]="option.value">
                    {{ option.label | translate }}
                  </mat-option>
                }
              </mat-select>
            </glxy-form-field>
            <glxy-label style="padding-bottom: 24px">{{
              'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.DELAY_SUFFIX_NEW' | translate
            }}</glxy-label>
          </div>

          <mat-card class="asst-details-card" appearance="outlined">
            <mat-card-content class="asst-details-content">
              <glxy-avatar
                width="52"
                class="assistant-avatar"
                [name]="assistantName()"
                [src]="assetPath('ai-reputation.jpg')"
              ></glxy-avatar>
              <div class="assistant-name">
                @if (assistantName()) {
                  <glxy-label>{{ assistantName() }}</glxy-label>
                  <glxy-label-hint>{{
                    'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.ASSISTANT_ROLE' | translate
                  }}</glxy-label-hint>
                } @else {
                  <glxy-loading-spinner size="small"></glxy-loading-spinner>
                }
              </div>
              <button (click)="goToConfigPage()" style="margin-left: auto" mat-stroked-button>
                {{ 'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.CONFIGURE_BUTTON' | translate }}
              </button>
            </mat-card-content>
          </mat-card>
        </mat-card-content>
      </mat-card>
    </form>
    <glxy-sticky-footer>
      <button mat-flat-button color="primary" [disabled]="isLoading() || !isFormDirty()" (click)="onSave()">
        <glxy-button-loading-indicator [isLoading]="isLoading()">
          {{ 'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.SAVE_BUTTON' | translate }}
        </glxy-button-loading-indicator>
      </button>
      <button mat-stroked-button (click)="goToConfigPage()" [disabled]="isLoading()">
        {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
      </button>
    </glxy-sticky-footer>
  </glxy-page-wrapper>
</glxy-page>
